// Taken from https://community.shopify.com/c/Shopify-Design/Ordinal-Number-in-javascript-1st-2nd-3rd-4th/m-p/72156
export function numToOrdinal(number) {
  const suffixes = ['th', 'st', 'nd', 'rd']
  const v = number % 100
  const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]
  return `${number}${suffix}`
}

export function isIe() {
  const ua = window.navigator.userAgent
  return (
    ua.indexOf('MSIE') !== -1 || !!navigator.userAgent.match(/Trident.*rv:11\./)
  )
}

//https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
export function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function isWindowsOS() {
  return window.navigator.platform.toLocaleLowerCase() === 'win32'
}

/**
 * Searches within a string for another string insensitive to case
 * @param {string} haystack - The string to search within
 * @param {string} needle - The string to search the haystack with
 * @returns {boolean}
 */
export function stringIncludesCaseInsensitive(haystack, needle) {
  if (
    !haystack ||
    !needle ||
    !haystack.toLowerCase ||
    !needle.toLowerCase ||
    haystack.length < needle.length
  ) {
    return false
  }
  return haystack.toLowerCase().includes(needle.toLowerCase())
}

/**
 * @param {string} str1
 * @param {string} str2
 * @returns {boolean}
 */
export function stringEqualsCaseInsensitive(str1, str2) {
  if (!str1 || !str2 || !str1.toLowerCase || !str2.toLowerCase) return false

  return str1.toLowerCase() === str2.toLowerCase()
}

/**
 * @param {string} inString
 * @returns {string}
 */
export function toSentenceCase(inString) {
  if (!inString) {
    return ''
  }

  return (
    String(inString).charAt(0).toUpperCase() +
    String(inString).slice(1).toLowerCase()
  )
}
